<section class="skillsWrap">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar> 
  </div>
  <div class="right-panel workadd">

      <form class="workScroll">
          <h4 class="pageTitle">Work experience<a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn" (click)="openModal(addMore)"> <i class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More </a></h4>

          <div class="education_added">
            <ul class="timeline"> 
                <li *ngFor="let data of allData; let i =index">
              <div class="work-des mb-3" >
                  <p> <strong class="firstlCaptial">{{data.companyName || 'N/A'}}</strong> <span class="time" *ngIf="data?.employementTypeDetails?.name">  {{data?.employementTypeDetails?.name || 'N/A'}}</span>
                  <a href="javascript:;" title="Edit"><img src="assets/images/ic_edit.svg" class="ht" (click)="edit(data,addMore)"> </a>
                  <a href="javascript:;" title="Delete"><img src="assets/images/ic_delete.svg" class="ht" (click)="delete(data.id)"> </a>
              </p>
                  <p class="exp para3">{{dateAgo(data?.fromDate,data?.toDate)}}</p>
            </div>          
                   
                      <span class="timeline-point-circle fill"></span>
                      <div class="el_details"> 
                          <p> <strong class="firstlCaptial">{{data.jobTitle || 'N/A'}}</strong> </p> 
                          <span> {{data?.fromDate ? (data?.fromDate | date) : "N/A" }} - {{data?.toDate ? (data?.toDate | date) : "Till date"}}</span>
                      </div>
                      <div class="row">
                          <div class="col-12">
                              <div class="expinner">
                                  <h6 class="companyname" style="justify-content: flex-start;"><strong class="firstlCaptial">{{data.companyName}}</strong> <span class="time" *ngIf="data?.employementTypeDetails?.name">{{data?.employementTypeDetails?.name}}</span> </h6>
                                  <p class="designation"><span class="firstlCaptial">{{data.jobTitle}}</span></p>
                                  <p class="date">{{data.fromDate | date}} - {{data?.toDate ? (data?.toDate | date) : "Till date"}} </p>
                                  <p class="place">{{data.location}}</p>
                               </div>   

                            </div>
                            <!-- <div class="col-sm-3 col-md-3 col-lg-3">
                            <div class="expinner">
                              <h6 class="companyname">Cognizant<span class="time">Contractual</span> </h6>
                              <p class="designation">Sr. UX Designer</p>
                              <p class="date">Jan 22, 2020 - Jan 23, 2022 </p>
                              <p class="place">Florida, CA</p>
                           </div>   

                        </div>

                        <div class="col-sm-3 col-md-3 col-lg-3">
                        <div class="expinner">
                          <h6 class="companyname">Google<span class="time">Contractual</span> </h6>
                          <p class="designation">Sr. UX Designer</p>
                          <p class="date">Jan 22, 2022 - Jan 23, 2023 </p>
                          <p class="place">Florida, CA</p>
                       </div>   

                    </div> -->
                      </div>
                  </li> 
              </ul>
          </div>

          <div class="form-group bottom ">
              <a href="javascript:void(0)" routerLink="/volunteer" class="commonBtn width50 mt-5">Continue</a>
          </div>

      </form>
  </div>
</section>

<ng-template #addMore>
  <div class="modal-body">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()"><span aria-hidden="true">×</span></button>             
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h4 class="pageTitle"> {{title}} Work experience</h4>
      <div class="row">
          <div class="col-md-6 col-lg-6 ">
              <div class="form-group">
                  <label>Job title<span class="orangeText">*</span> </label>
                  <input  type="text" name="" class="form-control upper" placeholder="Enter a job title" formControlName="jobTitle" maxLength="50">
                  <div class="text-danger" *ngIf="form.controls['jobTitle'].hasError('required') && showError">
                    *Please enter Job title.
                 </div>
                  <div class="text-danger" *ngIf="form.controls['jobTitle'].hasError('maxLength') && showError">
                    *Maximum length of 50 characters.
                 </div>
              </div>
          </div>
          <div class="col-md-6 col-lg-6 ">
              <div class="form-group">
                  <label> Company<span class="orangeText">*</span> </label>
                  <input  type="text" name="" class="form-control upper" placeholder="Enter Company" formControlName="companyName" maxLength="50">
                <div class="text-danger" *ngIf="form.controls['companyName'].hasError('required') && showError">
                  *Please enter company name.
              </div>
              <div class="text-danger" *ngIf="form.controls['companyName'].hasError('maxlength') && showError">
                *Maximum length of 50 characters.
             </div>
              </div>
          </div>
          <div class="col-md-12 col-lg-12 col-sm-12 ">     
          <h5 class="subTitle2 mb-0"> Employment type </h5>
          <div class="form-group">
            <ul class="suggestedskills">
                <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmployment(i,$event)" [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li> 
            </ul>
            <div class="text-danger" *ngIf="form.controls['employementTypeId'].hasError('required') && showError">
                *Please enter employement type.
            </div>
          </div>
          </div>
          
    
          <div class="col-md-6 col-lg-6 col-sm-12" *ngIf="showContract">
              <div class="form-group">
                  <label> Under contract of</label>
                  <input type="text" name="" class="form-control upper" placeholder="Infosys" formControlName="underContractOf">
                      <div class="text-danger" *ngIf="form.controls['underContractOf'].hasError('required') && showError">
                          *Please enter under contract of.
                      </div>
              </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-12 ">
              <div class="form-group upperLetter">
                  <label> Location</label>
                  <input type="text" name="" class="form-control upper" placeholder="Enter location"  formControlName="location">
                   <div class="text-danger" *ngIf="form.controls['location'].hasError('required') && showError">
                          *Please enter location.
                      </div>
              </div>
          </div>
           
          <div class="col-md-6 col-lg-6 ">
              <div class=" d-flex justify-content-between">
                  <div class="form-group">
                      <label> From<span class="orangeText">*</span></label>
                      <div id="date-picker-example" class="datepicker">
                        <input type="text" autocomplete="off" class="form-control" placeholder="Enter date" [bsValue]="form.value.fromDate"  bsDatepicker placement="bottom"[bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" formControlName="fromDate" [maxDate]="maxDate" (keydown)="onKeyDown($event)">
                        <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                    </div>
                    <div class="text-danger" *ngIf="showError == true && form.controls['fromDate'].hasError('required')">*Please select From</div>
                  </div>
                  
                  <div class="form-group">
                      <label> To<span class="orangeText">*</span></label>
                      <div id="date-picker-example" class="datepicker">
                        <input type="text" placeholder="Enter date"
                        class="form-control" bsDatepicker
                        [minDate]="form.value.fromDate == '' ? minDate : form.value.fromDate"
                        formControlName="toDate"
                        [bsValue]="form.value.toDate" [maxDate]="maxDate"
                        [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }" (keydown)="onKeyDown($event)">
                        <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                    </div>
                    <div class="text-danger" *ngIf="showError == true && form.controls['toDate'].hasError('required')">*Please select To</div>
                  </div>
              </div>
          </div>
          <div class="col-md-12 col-lg-12  col-sm-12">
              <div class="form-group">
                  <label> Description </label>
                  <textarea type="text" class="form-control" placeholder="As a team lead, a UX manager sets design standards for the team and trains and supports the team in UX best practices." formControlName="description" maxlength="250"></textarea>
                  <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                      *Please enter description.
                  </div>
                  <div class="text-danger" *ngIf="form.controls['description'].hasError('minlength') && showError">
                      *Minimum length of 3 characters.
                  </div>
                  <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                      *Minimum length of 250 characters.
                  </div>
              </div>
          </div>

          <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group pt-2">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isCurrentlyRole"  [value]="1" [checked]="form.value.isCurrentlyRole == 1" (change)="form.value.isCurrentlyRole = 1;isDisabled($event)">
                      <label class="custom-control-label" for="customCheckBox1"> I am currently working in this role</label>
                      <div class="text-danger" *ngIf="form.controls['isCurrentlyRole'].hasError('required') && showError">
                        *Please select I am currently working in this role.
                    </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="form-group ">
        <input type="submit" value="Save"  class="commonBtn width50 mt-4">
          <!-- <a href="work_added.html" class="commonBtn width50 "> Save </a> -->
      </div>

  </form>
  </div>
</ng-template>